import { render, staticRenderFns } from "./CodSnackbar.vue?vue&type=template&id=d57afbc6&scoped=true&"
import script from "./CodSnackbar.vue?vue&type=script&lang=js&"
export * from "./CodSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./CodSnackbar.vue?vue&type=style&index=0&id=d57afbc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57afbc6",
  null
  
)

export default component.exports